import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import formStyles from "../../newFlowForm.module.css";

const FeedbacksForm = ({
  brand,
  flowName,
  flowVersion,
  onValidate,
  setFormErrors,
}) => {
  const [displayBrand, setDisplayBrand] = useState("");
  const [primaryColor, setPrimaryColor] = useState("rgba(0,0,0,1)");
  const [logoLink, setLogoLink] = useState("");
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleColorIconClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleColorChangeComplete = (color) => {
    setPrimaryColor(
      `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`
    );
  };

  const handleValidateButtonClick = function () {
    setFormErrors([]);
    let invalidForm = false;

    if (!brand.length) {
      setFormErrors((prev) => [
        ...prev,
        { field: "brand", message: "Brand filed is required" },
      ]);
      invalidForm = true;
    }
    if (!flowName.length) {
      setFormErrors((prev) => [
        ...prev,
        { field: "flowName", message: "Flow name field is required" },
      ]);
      invalidForm = true;
    }
    if (!flowVersion.length) {
      setFormErrors((prev) => [
        ...prev,
        { field: "flowVersion", message: "Flow version field is required" },
      ]);
      invalidForm = true;
    }
    if (!displayBrand.length) {
      setFormErrors((prev) => [
        ...prev,
        { field: "displayBrand", message: "Display Brand field is required" },
      ]);
      invalidForm = true;
    }
    if (!primaryColor.length) {
      setFormErrors((prev) => [
        ...prev,
        { field: "primaryColor", message: "Primary Color field is required" },
      ]);
      invalidForm = true;
    }
    if (!logoLink.length) {
      setFormErrors((prev) => [
        ...prev,
        { field: "logoLink", message: "Logo Link field is required" },
      ]);
      invalidForm = true;
    }

    if (invalidForm) {
      return;
    }

    onValidate({
      brand: brand,
      name: flowName,
      version: flowVersion,
      displayName: displayBrand,
      color: primaryColor,
      logo_link: logoLink,
      template: "feedbacksTemplate",
    });
  };

  return (
    <div>
      <div className={formStyles.form_control}>
        <div>
          <label className={formStyles.form_label}>Display Brand</label>
        </div>
        <input
          type="text"
          value={displayBrand}
          onChange={(e) => setDisplayBrand(e.target.value)}
        />
      </div>
      <div className={formStyles.form_control}>
        <div>
          <div>
            <label className={formStyles.form_label}>Primary Color</label>
          </div>
          <div
            onClick={handleColorIconClick}
            className={formStyles.colorPickerIcon}
            style={{
              backgroundColor: primaryColor,
            }}
          ></div>
        </div>
        {displayColorPicker ? (
          <div className={formStyles.colorPickerContainer}>
            <SketchPicker
              color={primaryColor}
              onChangeComplete={handleColorChangeComplete}
            />
          </div>
        ) : null}
      </div>
      <div className={formStyles.form_control}>
        <div>
          <label className={formStyles.form_label}>Logo Link</label>
        </div>
        <input
          type="text"
          value={logoLink}
          onChange={(e) => setLogoLink(e.target.value)}
        />
      </div>
      <div className={formStyles.validate_button_container}>
        <button
          className={formStyles.validate_button}
          onClick={handleValidateButtonClick}
        >
          Create
        </button>
      </div>
    </div>
  );
};

export default FeedbacksForm;
